<script setup lang="ts">
import type { ShortcutJs } from "@/generated/models";
import EmbedLinkForm from "ls/features/disko/links/EmbedLinkForm.vue";
import { useCurrentFileContext } from "ls/features/disko/useCurrentFileContext";
import { isBookmarkShortcut } from "ls/features/files/utils";

const emit = defineEmits<{
  submit: [string];
  cancel: [];
}>();

const url = defineModel<string>("url", { required: true });

const { shortcut } = useCurrentFileContext();

function submit(url: string) {
  emit("submit", url);
}

function handleKeyDownEscape() {
  emit("cancel");
}

function bookmarksFilter(shortcut: ShortcutJs) {
  return !isBookmarkShortcut(shortcut);
}
</script>

<template>
  <div
    class="flex max-h-96 min-h-0 w-80 flex-col"
  >
    <EmbedLinkForm
      v-model="url"
      :shortcut="shortcut"
      :filter-files="bookmarksFilter"
      @submit="submit"
      @cancel="handleKeyDownEscape"
    />
  </div>
</template>
